import { render, staticRenderFns } from "./CreateProcedures.vue?vue&type=template&id=099e48d8"
import script from "./CreateProcedures.vue?vue&type=script&lang=js"
export * from "./CreateProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports